<template>
  <div id="app">
    <!-- <AnswerIndex/> -->
    <router-view></router-view>
    <el-backtop :visibility-height="300">
      <i class="el-icon-caret-top"></i>
    </el-backtop>
  </div>
</template>

<script>
// import AnswerIndex from './components/MainPage/AnswerIndex.vue'

export default {
  name: 'App',
  components: {
    // AnswerIndex
  }
}
</script>

<style>

</style>
